import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p394056289720737792',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
